import { SVGProps } from '@components/Icon/types';

export const DayOff = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 2)">
      <path
        d="M12.3652 9.20508C12.6386 8.93189 13.0812 8.93192 13.3545 9.20508C13.6279 9.47845 13.6279 9.92195 13.3545 10.1953L11.0195 12.5293L13.3545 14.8652C13.6278 15.1386 13.6278 15.5811 13.3545 15.8545C13.0811 16.1279 12.6386 16.1279 12.3652 15.8545L10.0293 13.5195L7.69531 15.8545C7.42195 16.1279 6.97845 16.1279 6.70508 15.8545C6.43189 15.5811 6.4318 15.1385 6.70508 14.8652L9.04004 12.5293L6.70508 10.1953C6.43171 9.92195 6.43171 9.47845 6.70508 9.20508C6.97845 8.93176 7.42196 8.93173 7.69531 9.20508L10.0293 11.54L12.3652 9.20508Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 0C18.2091 0 20 1.79086 20 4V16C20 18.14 18.3194 19.8879 16.2061 19.9951L16 20H4L3.79395 19.9951C1.7488 19.8913 0.108652 18.2512 0.00488281 16.2061L0 16V4C0 1.79086 1.79086 3.22128e-08 4 0H16ZM1.40039 16C1.40039 17.4359 2.56406 18.5996 4 18.5996H16C17.4359 18.5996 18.5996 17.4359 18.5996 16V6H1.40039V16ZM4 1.40039C2.56406 1.40039 1.40039 2.56406 1.40039 4V4.59961H18.5996V4C18.5996 2.56406 17.4359 1.40039 16 1.40039H4Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'day-off';
